import { NgClass } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AbstractFormFieldComponent } from '../../abstract-form-field.component';
import { ToggleFormField } from '../../form-field.model';

@Component({
  selector: 'iot-platform-ui-form-toggle-field',
  imports: [
    FlexLayoutModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatTooltipModule,
    FormsModule,
    NgClass,
    MatSlideToggleModule
  ],
  templateUrl: './form-toggle-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../form-field/form-field.component.scss'
})
export class FormToggleFieldComponent extends AbstractFormFieldComponent<ToggleFormField> {}
